// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2gp_4","file":"styles_file__2PJt5"};